export enum Feature {
	ConoceMasVigilancia = 'conocemasvigilancia',
	ConoceMasEstadosPago = 'conocemasestadospago',
	ConoceMasDatosEmpresa = 'conocemasdatosempresa',
	ConoceMasCertificados = 'conocemascertificados',
	ConoceMasSiniestrosEmpresa = 'conocemassiniestrosempresa',
	ContactabilidadEmpresa = 'contactabilidadempresa',
	Dynatrace = 'dynatrace',
	HistoricoMisCitas = 'historicomiscitas',
	ProximasCitasCaracteristicas = 'proximascitascaracteristicas',
	BannerEnterpriseCommitment = 'bannerenterprisecommitment',
	ContactEnterpriseNavbarButton = 'contactEnterpriseNavbarButton',
	CommitmentNavbarButton = 'commitmentNavbarButton',
	TourCommitment = 'TourCommitment',
	DrawerKarin = 'drawerkarin',
	EmployeeMenu = 'employeeMenu',
	NavMenuV2 = 'navMenuv2',
	HelpDrawer = 'helpdrawer',
	HideMenuTour = 'hideMenuTour',
	NuevoNombreContactoEmpresa = 'nuevoNombreContactoEmpresa',
	BulkAsignaciones = 'bulkAsignaciones',
	DS67 = 'ds67',
}

export const featureFlags: Record<Feature | string, boolean> = {
	[Feature.ConoceMasVigilancia]: false,
	[Feature.ConoceMasEstadosPago]: false,
	[Feature.ConoceMasDatosEmpresa]: false,
	[Feature.ConoceMasCertificados]: false,
	[Feature.ConoceMasSiniestrosEmpresa]: false,
	[Feature.ContactabilidadEmpresa]: false,
	[Feature.Dynatrace]: false,
	[Feature.HistoricoMisCitas]: true,
	[Feature.ProximasCitasCaracteristicas]: true,
	[Feature.BannerEnterpriseCommitment]: false,
	[Feature.ContactEnterpriseNavbarButton]: true,
	[Feature.CommitmentNavbarButton]: false,
	[Feature.TourCommitment]: true,
	[Feature.DrawerKarin]: true,
	[Feature.EmployeeMenu]: true,
	[Feature.NavMenuV2]: true,
	[Feature.HelpDrawer]: true,
	[Feature.HideMenuTour]: true,
	[Feature.NuevoNombreContactoEmpresa]: true,
	[Feature.BulkAsignaciones]: false,
	[Feature.DS67]: false
};
